import DisplayPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/multiLineInput/components/MultiLineInputDisplayPart';
import FormPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/multiLineInput/components/MultiLineInputFormPart';

export default {
  DisplayPart,
  FormPart,
};
